import * as tslib_1 from "tslib";
import getSkypeOptions from '../data/store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { action, select } from 'satcheljs/lib/legacy';
import { getOptionsForFeature, lazyCreateOrUpdateOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
export default select({
    optionState: function () { return getSkypeOptions(); },
    userOptions: function () {
        return getOptionsForFeature(OwsOptionsFeatureType.SkypeNotifications);
    },
})(action('saveSkypeOptions')(function saveSkypeOptions(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.skypeMessageNotification = getFallbackValueIfNull(optionState.imNotification, userOptions.skypeMessageNotification);
                    userOptions.skypeCallingNotification = getFallbackValueIfNull(optionState.callNotification, userOptions.skypeCallingNotification);
                    return [4 /*yield*/, lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.SkypeNotifications, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSkypeOptions.js.map